import { CommandActionAsync } from "src/app/abstract/command/command-action-async.service";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { Injectable } from "@angular/core";
import { CloneService } from "../clone/clone.service";
import { WidgetsService } from "../widgets/widgets.service";
import { Logger } from "src/app/core/logger";
import { WidgetsMetadataService } from "../widgets/widgets-metadata.service";

@Injectable()
export class CommandDeleteNodeService extends CommandActionAsync {
    constructor(private widgetsCloneService: CloneService,
        private widgetsService: WidgetsService,    
        private widgetsMetadataService: WidgetsMetadataService,
        private logger:Logger) {
        super();
    }

    /**
     * Resequence questions inside a provided root node
     * @param nodeToDelete Node to be deleted with all children
     * @param unused
     * @returns Number of Questions hit
     */
    public async executeAsync(nodeToDelete:WidgetsAbstract, unused: WidgetsAbstract|undefined): Promise<boolean> {
        if (nodeToDelete) {
            const deleted : boolean = await this.widgetsService.deleteNode(nodeToDelete);
            if (deleted) {
                this.logger.log('Deleted node (' + deleted + ')' );                
                return deleted;
            } else
                throw new Error("No node Deleted");           
        }
        throw new Error("Origin Node is null/undefined. Can't resequence.");
    }
}
